const initialDialogState = { type: "", data: null };

const dialogReducer = (dialog = initialDialogState, action) => {
  return action.type ? action : initialDialogState;
};

export default dialogReducer;
